import { EmpresasListGrouping } from './EmpresasListGrouping'
import { EmpresasListSearchComponent } from './EmpresasListSearchComponent'
import { useListView } from '../../core/ListViewProvider'
import { EmpresasListToolbar } from './EmpresasListToolbar'

export const EmpresasListHeader = () => {
  const { selected } = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <EmpresasListSearchComponent
        actions={selected.length > 0 ? <EmpresasListGrouping /> : <EmpresasListToolbar />}
      />
    </div>
  )
}
